import { type MetaFunction } from 'react-router';

import ContactUsPage from '../../src/pages/ContactUsPage';

export const meta: MetaFunction = () => {
  return [
    { title: 'Contact Us | Atrivial' },
    { name: 'description', content: 'Contact Atrivial for support, partnerships, or feedback.' },
  ];
};

export default function ContactUs() {
  return <ContactUsPage />;
}
